import React from 'react'
import { components } from 'cng-web-lib'
import ShippingInstructionTranslationText from 'src/views/shippinginstruction/ShippingInstructionTranslationText'
import PrintIcon from '@material-ui/icons/Print'
const {
  button: { CngPrimaryButton, CngSecondaryButton }
} = components

function PrintBLButton(buttonProps) {
  const isPrimary = buttonProps.isPrimary
  const translatedTextsObject = ShippingInstructionTranslationText()
  return (
    <div>
      {isPrimary ? (
        <CngPrimaryButton {...buttonProps}>
          <PrintIcon />
          {translatedTextsObject.printBl}
        </CngPrimaryButton>
      ) : (
        <CngSecondaryButton {...buttonProps}>
          <PrintIcon />
          {translatedTextsObject.printBl}
        </CngSecondaryButton>
      )}
    </div>
  )
}

export default PrintBLButton
